import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HIGHLIGHT_TITLE } from '../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HighlightTitle = ({
  i18nKey,
  title
}) => /*#__PURE__*/_jsxs(H2, {
  "data-test-id": HIGHLIGHT_TITLE,
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey
  }), title ? /*#__PURE__*/_jsxs("span", {
    children: [" ", title]
  }) : '']
});
export default HighlightTitle;